import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=a2fea148&lang=pug&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2fea148')) {
      api.createRecord('a2fea148', component.options)
    } else {
      api.reload('a2fea148', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=a2fea148&lang=pug&", function () {
      api.rerender('a2fea148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Banner.vue"
export default component.exports